import React from 'react';
import { EvalAnswers, EvalOption, Tags } from '../common/page-data';
import { bulletList, joinElementList } from '..';
import Grid from '@mui/material/Grid';
import { TagListAnswer } from './tag-list-answer';
interface ComponentProps {
  tags: Tags;
  evalAnswers: EvalAnswers;
  disabled?: boolean;
  positive?: boolean;
  onChange?: (evalAnswers: EvalAnswers) => void;
}

type Props = ComponentProps;

const TagListComp: React.FC<Props> = (props) => {
  const { tags, evalAnswers, disabled } = props;

  const answer = evalAnswers[Object.keys(tags)[0]];

  const onChange = (answer: EvalOption) => {
    if (props.onChange) {
      const newEvalAnswers = { ...evalAnswers };
      Object.values(tags).forEach((tag) => {
        newEvalAnswers[tag.id] = answer;
      });
      props.onChange(newEvalAnswers);
    }
  };

  const tagText = joinElementList(
    Object.values(tags).map((v) => v.reason.gerund),
    'or'
  );

  const reasonText = bulletList(
    Object.values(tags).map(
      (v) => v.explanation.markdown || v.explanation.text || ''
    )
  );

  return (
    <Grid container sx={{ ml: 3 }} spacing='5'>
      <TagListAnswer
        tagText={tagText}
        reasonText={reasonText}
        evalOption={answer}
        onChange={(answer: EvalOption) => onChange(answer)}
        positive
        disabled={disabled}
      />
    </Grid>
  );
};

//******************************************************************************
export const PositiveTagList = TagListComp;
